import { InMemoryCache } from 'apollo-cache-inmemory';
import ApolloClient from 'apollo-client';
import { onError } from 'apollo-link-error';
import { createHttpLink } from 'apollo-link-http';
import fetch from 'node-fetch';
import * as authUtils from './auth0-pcke';
import { GRAPHQL_ENDPOINT } from './environment';

export function client() {
  const errorLink = onError(({ response, graphQLErrors, networkError }) => {
    if (graphQLErrors) {
      graphQLErrors.forEach(({ message }) => {
        console.error(message);
      });
    } else if (networkError) {
      const n: any = networkError;
      if (n.error && n.error.errors && n.error.errors.length > 0) {
        const message = n.error.errors[0].message;
        console.error(message);
      } else {
        console.error(n.message);
      }
    }
  });

  return new ApolloClient({
    link: errorLink.concat(
      createHttpLink({
        uri: GRAPHQL_ENDPOINT,
        fetch: fetch as any,
        headers: createHeaders()
      })
    ),
    cache: new InMemoryCache(),
    defaultOptions: {
      query: { fetchPolicy: 'network-only' },
      watchQuery: { fetchPolicy: 'network-only' }
    }
  });
}

function createHeaders() {
  const token = authUtils.getAccessTokenFromStore();
  const idToken = authUtils.getIdTokenFromStore();

  return {
    Authorization: `bearer ${token}`,
    idToken: idToken
  };
}
